import React, { FC } from 'react'
import { FileWithPreview, UISizes, UITypes } from 'LibNeo'
import { Callback } from 'Types/utilTypes'
import { FileStatuses, MouseEventFunction } from 'Modules'
import { FileInfo, FileLink, FileName, FileNameWrapper, FileWrapper, Icon } from './styled'

interface ComponentProps {
	statusFile: FileStatuses
	showFilePreview?: Callback<FileWithPreview, MouseEventFunction>
	fileName: string
	file: FileWithPreview
	renderDeleteFileButton?: () => JSX.Element | null
	fileInfo?: string
}

const statusState = {
	fileIcon: {
		[FileStatuses.LOADING]: 'loader',
		[FileStatuses.ERROR]: 'info',
		[FileStatuses.COMPLETE]: 'attachment',
	},
	fileIconType: {
		[FileStatuses.LOADING]: UITypes.PRIMARY as const,
		[FileStatuses.ERROR]: UITypes.DANGER as const,
		[FileStatuses.COMPLETE]: UITypes.GREY as const,
	},
	fileLinkType: {
		[FileStatuses.LOADING]: UITypes.PASSIVE as const,
		[FileStatuses.ERROR]: UITypes.DANGER as const,
		[FileStatuses.COMPLETE]: UITypes.BLACK as const,
	},
}

export const FileContentView: FC<ComponentProps> = ({
	statusFile,
	showFilePreview,
	fileName,
	file,
	renderDeleteFileButton,
	fileInfo,
}) => (
	<FileWrapper>
		<Icon
			name={statusState.fileIcon[statusFile]}
			size={UISizes.SMALL}
			type={statusState.fileIconType[statusFile]}
			onClick={showFilePreview?.(file)}
		/>
		<FileNameWrapper>
			<FileName notView={!file?.preview}>
				<FileLink
					type={statusState.fileLinkType[statusFile]}
					title={fileName}
					onClick={showFilePreview?.(file)}
				/>
			</FileName>
		</FileNameWrapper>
		{statusFile !== FileStatuses.LOADING && <FileInfo $status={statusFile}>{fileInfo}</FileInfo>}
		{renderDeleteFileButton?.()}
	</FileWrapper>
)
